import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cny-per-m',
  templateUrl: './cny-per-m.component.html',
  styleUrls: ['./cny-per-m.component.scss']
})
export class CnyPerMComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
